import { render, staticRenderFns } from "./QualityReport.vue?vue&type=template&id=1d222fa4"
import script from "./QualityReport.vue?vue&type=script&lang=js"
export * from "./QualityReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d222fa4')) {
      api.createRecord('1d222fa4', component.options)
    } else {
      api.reload('1d222fa4', component.options)
    }
    module.hot.accept("./QualityReport.vue?vue&type=template&id=1d222fa4", function () {
      api.rerender('1d222fa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/pages/QualityReport.vue"
export default component.exports